import "core-js/modules/es.array.map.js";
import { Swiper, SwiperSlide } from 'swiper/react';
import classnames from 'classnames';
import Colors from "../Color/Colors";
import { Icon } from "../Icon/Icon/Icon";
import { Button } from "../Button/Button/Button";
import 'swiper/swiper.min.css';
import styles from "./LinksBar.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var LinksBar = function LinksBar(_ref) {
  var linksArray = _ref.linksArray,
    variant = _ref.variant;
  var renderNavLinks = function renderNavLinks() {
    return linksArray.map(function (link, i) {
      return /*#__PURE__*/_jsx(SwiperSlide, {
        style: {
          width: 'auto'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: classnames(styles.link, styles.noSwiping, {
            [styles.navLinkPadding]: i !== 0
          }),
          children: /*#__PURE__*/_jsx(Button, {
            accessibilityLabel: link.accessibilityLabel,
            className: styles.navLink,
            type: "no-style",
            newWindow: link.newWindow,
            url: link.url,
            children: /*#__PURE__*/_jsx("span", {
              className: styles.navText,
              children: link.text
            })
          })
        }, i)
      }, i);
    });
  };
  var renderBreadcrumbs = function renderBreadcrumbs() {
    return linksArray.map(function (link, i) {
      var linkText = /*#__PURE__*/_jsx("span", {
        className: classnames(styles.breadcrumbText, {
          [styles.breadcrumbTextNoLink]: !link.url
        }),
        children: link.text
      });
      return /*#__PURE__*/_jsxs("div", {
        className: styles.breadcrumbWrapper,
        children: [i !== 0 && /*#__PURE__*/_jsx(Icon, {
          className: styles.iconPadding,
          fill: Colors.colorBlack,
          height: "9px",
          type: "arrow-right-2"
        }), link.url ? /*#__PURE__*/_jsx(Button, {
          accessibilityLabel: link.accessibilityLabel,
          className: styles.breadcrumbLink,
          type: "no-style",
          newWindow: link.newWindow,
          url: link.url,
          children: linkText
        }) : linkText]
      }, i);
    });
  };
  var renderLinksBar = function renderLinksBar() {
    if (variant === 'navigation') {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("hr", {
          className: styles.lineBreak
        }), /*#__PURE__*/_jsx("div", {
          className: styles.swiperContainer,
          children: /*#__PURE__*/_jsx(Swiper, {
            simulateTouch: false,
            slidesPerView: "auto",
            children: renderNavLinks()
          })
        }), /*#__PURE__*/_jsx("hr", {
          className: styles.lineBreak
        })]
      });
    } else if (variant === 'breadcrumbs') {
      return /*#__PURE__*/_jsx("div", {
        className: styles.breadcrumbsContainer,
        children: renderBreadcrumbs()
      });
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderLinksBar()
  });
};